import request from '@/utils/request'


// 查询树列表
export function listInfo(query) {
  return request({
    url: '/tree/info/list',
    method: 'get',
    params: query
  })
}

// 查询树分页
export function pageInfo(query) {
  return request({
    url: '/tree/info/page',
    method: 'get',
    params: query
  })
}

// 查询树详细
export function getInfo(data) {
  return request({
    url: '/tree/info/detail',
    method: 'get',
    params: data
  })
}

// 新增树
export function addInfo(data) {
  return request({
    url: '/tree/info/add',
    method: 'post',
    data: data
  })
}

// 修改树
export function updateInfo(data) {
  return request({
    url: '/tree/info/edit',
    method: 'post',
    data: data
  })
}

// 删除树
export function delInfo(data) {
  return request({
    url: '/tree/info/delete',
    method: 'post',
    data: data
  })
}
